import React from "react";
//import PropTypes from 'prop-types';
import DebugConsole from "./DebugConsole";
import { useData } from "state/hooks";
import { useEditorState } from "playground/designer/EditorState";

export function DebugConsoleContainer(props) {
    const { path } = props;
    const [type, id] = path ? path.split("/") : [];
    const state = useData({ type, id });
    const [editorState] = useEditorState();

    let output = state;
    let visiblePath = path;

    if (path === "editorState") {
        output = editorState;
    }

    if (path && path.indexOf("code://") === 0) {
        const code = path.substring(7);
        output = code;
        visiblePath = "code";
    }

    return <DebugConsole {...props} state={output} path={visiblePath} />;
}

DebugConsoleContainer.propTypes = {};

DebugConsoleContainer.defaultProps = {};

export default DebugConsoleContainer;
